import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const { t } = useTranslation();
  const features = [
    { icon: 'BarChart3', titleKey: 'landing.features.f1Title', descKey: 'landing.features.f1Desc', tagKeys: ['landing.features.f1Tag1', 'landing.features.f1Tag2', 'landing.features.f1Tag3'] },
    { icon: 'Shield',    titleKey: 'landing.features.f2Title', descKey: 'landing.features.f2Desc', tagKeys: ['landing.features.f2Tag1', 'landing.features.f2Tag2', 'landing.features.f2Tag3'] },
    { icon: 'Users',     titleKey: 'landing.features.f3Title', descKey: 'landing.features.f3Desc', tagKeys: ['landing.features.f3Tag1', 'landing.features.f3Tag2', 'landing.features.f3Tag3'] },
    { icon: 'Database',  titleKey: 'landing.features.f4Title', descKey: 'landing.features.f4Desc', tagKeys: ['landing.features.f4Tag1', 'landing.features.f4Tag2', 'landing.features.f4Tag3'] },
    { icon: 'FileText',  titleKey: 'landing.features.f5Title', descKey: 'landing.features.f5Desc', tagKeys: ['landing.features.f5Tag1', 'landing.features.f5Tag2', 'landing.features.f5Tag3'] },
    { icon: 'Settings',  titleKey: 'landing.features.f6Title', descKey: 'landing.features.f6Desc', tagKeys: ['landing.features.f6Tag1', 'landing.features.f6Tag2', 'landing.features.f6Tag3'] },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
            <Icon name="Zap" size={16} />
            <span>{t('landing.features.badge')}</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
            {t('landing.features.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('landing.features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="group p-6 bg-card rounded-xl border border-border hover:shadow-lg transition-all duration-300 hover:border-primary/20"
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-all duration-300">
                <Icon name={feature?.icon} size={24} className="text-primary group-hover:text-white" />
              </div>

              {/* Content */}
              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-foreground">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {t(feature.descKey)}
                </p>

                {/* Highlights */}
                <div className="space-y-2">
                  {feature.tagKeys?.map((highlight, idx) => (
                    <div key={idx} className="flex items-center space-x-2">
                      <Icon name="Check" size={14} className="text-success flex-shrink-0" />
                      <span className="text-sm text-muted-foreground">{t(highlight)}</span>
                    </div>
                  ))}
                </div>

                {/* Learn More Link */}
                <button className="flex items-center space-x-2 text-primary font-medium hover:text-primary/80 transition-smooth group/link">
                  <span>{t('landing.features.learnMore')}</span>
                  <Icon name="ArrowRight" size={14} className="group-hover/link:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-muted-foreground mb-6">
            Ready to transform your pay transparency strategy?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-8 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-smooth">
              Sign In to Explore
            </button>
            <button className="px-8 py-3 border border-border text-foreground rounded-lg font-semibold hover:bg-muted transition-smooth">
              View Documentation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;